import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=62cf784e"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"
import style0 from "./StatsView.vue?vue&type=style&index=0&id=62cf784e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports